export const parseRestaurantId = (restaurantId: string | null): number | undefined => {
    const parsed = parseInt(restaurantId ?? '', 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
